import styled from 'styled-components'

export default styled.p`
  margin-bottom: 0.5rem;
  color: ${props => props.theme.colors.mutedText};
  font-size: 0.85rem;
`
